module.exports = __webpack_public_path__ + "img/fe8c233.png";